import translator from "@/translator";
import React, { useState } from "react";
import { Form, Input, Button, Space, Typography, Modal } from "antd";

const { TextArea } = Input;

const t = translator("note_office.views.notifications.notification_form.");

const { Text } = Typography;

const NotificationForm = ({
  form,
  notification,
  onSubmit,
  saving,
  onCancel,
  body,
  setBody,
  previewText,
  onRestore,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const maskItems = t("mask_modal.items", { returnObjects: true });

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      className="wrapper_form wrapper_form__with-button overflow"
    >
      <div>
        <h3>{t(`types_phrases.${notification.notification_type}`)}</h3>

        <Form.Item name="body">
          <div style={{ position: "relative" }}>
            <TextArea
              placeholder={t("placeholders.body")}
              className="contacts-form__input edit-notification-textarea"
              autoSize={{ minRows: 8 }}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />

            <Button
              type="default"
              size="small"
              onClick={() => setIsModalVisible(true)}
              className="button-masks"
            >
              {t("buttons.mask_button")}
              <span style={{ fontSize: 16, lineHeight: 1 }}>+</span>
            </Button>
          </div>
        </Form.Item>

        <Text className="contacts__label">{t("labels.preview")}</Text>

        <Form.Item>
          <TextArea
            value={previewText}
            autoSize={{ minRows: 5 }}
            readOnly
            style={{ backgroundColor: "#f5f5f5" }}
            className="contacts-form__input"
          />
        </Form.Item>

        <Button type="default" onClick={onRestore} block className="button-base button-green">
          {t("buttons.restore_template")}
        </Button>
      </div>

      <Form.Item style={{ marginBottom: "20px" }}>
        <Space direction="vertical" size={16} className="button-group">
          <Button type="primary" htmlType="submit" block loading={saving} className="button-base">
            {t("buttons.save")}
          </Button>
          {onCancel && (
            <Button
              type="default"
              block
              onClick={onCancel}
              className="button-base button-secondary"
            >
              {t("buttons.cancel")}
            </Button>
          )}
        </Space>
      </Form.Item>

      <Modal
        title={t("mask_modal.title")}
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
      >
        <ul style={{ paddingLeft: 10 }}>
          {Object.entries(maskItems).map(([key, description]) => (
            <li key={key}>
              <code>{`{${key}}`}</code> — {description}
            </li>
          ))}
        </ul>
      </Modal>
    </Form>
  );
};

export default NotificationForm;
